import { ID_PART_PATTERN, MAX_FIXTURE_ID_LENGTH } from "@zion/sdk-contracts";
//#region src/instance-identity.ts
/**
* ⛔ **RE-EXPORTED, not declared here.** `MAX_FIXTURE_ID_LENGTH` and
* {@link ID_PART_PATTERN} moved DOWN to `@zion/sdk-contracts`
* (`src/id-grammar.ts`) because the CP's app-facing input schemas live in that
* package and must bind the SAME domain this one enforces — and this package
* depends on it, so importing upward would be a cycle. The re-export keeps every
* existing consumer and this module's barrel entry byte-unchanged, with exactly
* one definition surviving. See `id-grammar.ts` for the measured reason a second
* copy was refused.
*/
/** Max length for an app ID component (30 chars). */
const MAX_APP_ID_LENGTH = 30;
/**
* Max length for a versionSlug component (16 chars). Matches the truncation
* behavior of `versionSlug()` in `desired-state.ts`. Values longer than
* this come from a bug — versionSlug should never produce them.
*/
const MAX_VERSION_SLUG_LENGTH = 16;
const DELIMITER = "--";
const VERSION_SLUG_PATTERN = /^v[a-z0-9]([a-z0-9]|-(?=[a-z0-9]))*$/;
/**
* Validate that an ID part is safe for use in instance keys.
* Must match: ^[a-z]([a-z0-9]|-(?=[a-z0-9]))*$
* (no leading/trailing hyphens, NO consecutive hyphens, no uppercase).
*/
function validateInstanceIdPart(id) {
	return ID_PART_PATTERN.test(id);
}
/** Validate a versionSlug — output of `versionSlug(version)`. */
function validateVersionSlug(slug) {
	return VERSION_SLUG_PATTERN.test(slug);
}
/** Serialize a fixture instance ID to a k8s-safe resource name. */
function instanceKey(id) {
	return `${id.appId}${DELIMITER}${id.fixtureId}`;
}
/**
* Serialize a versioned fixture instance ID to a per-version k8s resource
* name (plan 25). Used by `fixture-deployer.ts` for Deployment, Secret,
* ConfigMap, and KEDA ScaledObject names. NOT used for the stable Service
* or stable ServiceAccount — those use `instanceKey()` instead.
*/
function versionedInstanceKey(id) {
	return `${id.appId}${DELIMITER}${id.fixtureId}${DELIMITER}${id.versionSlug}`;
}
/** Parse a k8s resource name back to a fixture instance ID. */
function parseInstanceKey(key) {
	const delimiterIndex = key.indexOf(DELIMITER);
	if (delimiterIndex === -1) throw new Error(`Invalid instance key "${key}": missing "${DELIMITER}" delimiter`);
	if (key.indexOf(DELIMITER, delimiterIndex + 2) !== -1) throw new Error(`Invalid instance key "${key}": multiple "${DELIMITER}" delimiters`);
	const appId = key.slice(0, delimiterIndex);
	const fixtureId = key.slice(delimiterIndex + 2);
	if (appId.length === 0) throw new Error(`Invalid instance key "${key}": empty appId`);
	if (fixtureId.length === 0) throw new Error(`Invalid instance key "${key}": empty fixtureId`);
	return {
		appId,
		fixtureId
	};
}
//#endregion
export { ID_PART_PATTERN, MAX_APP_ID_LENGTH, MAX_FIXTURE_ID_LENGTH, MAX_VERSION_SLUG_LENGTH, VERSION_SLUG_PATTERN, instanceKey, parseInstanceKey, validateInstanceIdPart, validateVersionSlug, versionedInstanceKey };

//# sourceMappingURL=instance-identity.js.map